var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcShowStats = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C97AA",
  strokeWidth: 2,
  d: "m7.5 5 4.737 5 4.737-5M7.5 13l4.737 5 4.737-5"
})));
export { SvgIcShowStats as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSA1TDEyLjIzNjggMTBMMTYuOTczNyA1TTcuNSAxM0wxMi4yMzY4IDE4TDE2Ljk3MzcgMTMiIHN0cm9rZT0iIzNDOTdBQSIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";